<h2 mat-dialog-title>Revisión importación gestoría</h2>

<mat-dialog-content>
  <p class="hint">
    Los importes salen del PDF de gestoría (para Holded). Salario/Obj. no se contrastan con Bisual: allí el bruto no equivale a la nómina.
    Especie ↔ Ret.flex: verde = coincide; ámbar = difiere. Puedes sincronizar una sola fila (icono nube) o todas. Al sincronizar, el PDF
    actualiza Ret.flex en Bisual. La cuenta 640 se rellena sola desde la nómina Holded del periodo (la que genera la recurrente) o desde el
    plan contable («Sueldo …»); solo pide elegirla si no encuentra ninguna. Si vuelves a subir un PDF con solo algunas páginas (p. ej. una
    nómina corregida), se actualizan esas filas y el resto se conserva en esta misma revisión.
  </p>

  <div class="table-wrap">
    <table class="review-table">
      <thead>
        <tr>
          <th>PDF</th>
          <th>Empleado Bisual</th>
          <th matTooltip="PDF: TOTAL DEVENGO completo (incluye BENEFICIO POR OBJETIVOS e INCENTIVO).">Salario</th>
          <th matTooltip="Desglose: solo «BENEFICIO POR OBJETIVOS». Ya está incluido en Salario; no sumar Obj. al Salario.">Obj.</th>
          <th>SS emp.</th>
          <th>Total SS</th>
          <th>IRPF</th>
          <th matTooltip="PDF: Val.prod.especie / COMIDA FLEX. Al confirmar se escribe en Ret.flex de Bisual.">Especie</th>
          <th>A pagar</th>
          @if (salary_accounts.length) {
            <th>Cuenta 640</th>
          }
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (draft of drafts; track draft.id) {
          @let bisual = bisualCompare(draft);
          <tr [class.unmatched]="!draft.payroll_id" [class.synced]="draft.status === 'synced'">
            <td class="name-cell">
              <div class="pdf-name">{{ draft.extracted_name }}</div>
              @if (draft.page_from && draft.page_to) {
                <div class="meta">pág. {{ draft.page_from }}–{{ draft.page_to }}</div>
              }
              @if (draft.error_message) {
                <div class="error">{{ draft.error_message }}</div>
              }
            </td>
            <td>
              <mat-form-field appearance="outline" class="dense select-field">
                <mat-select [(ngModel)]="draft.payroll_id" [name]="'payroll_' + draft.id">
                  <mat-option [value]="null">Sin asignar</mat-option>
                  @for (payroll of data.payrolls; track payroll.id) {
                    <mat-option [value]="payroll.id">{{ payrollLabel(payroll) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.salary" [name]="'salary_' + draft.id" />
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.objectives_bonus" [name]="'obj_' + draft.id" />
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.employer_ss" [name]="'ess_' + draft.id" />
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.total_ss" [name]="'tss_' + draft.id" />
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.irpf" [name]="'irpf_' + draft.id" />
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.in_kind" [name]="'ink_' + draft.id" />
              @if (bisual) {
                <div
                  class="bisual-ref"
                  [class.bisual-ref--match]="amountsMatch(draft.in_kind, bisual.flexible_remuneration)"
                  [class.bisual-ref--diff]="!amountsMatch(draft.in_kind, bisual.flexible_remuneration)"
                  matTooltip="Retribución flexible actual en Bisual (se actualizará con el PDF al confirmar)"
                >
                  Ret.flex {{ bisual.flexible_remuneration | number: '1.2-2' }} €
                </div>
              }
            </td>
            <td>
              <input class="amount" type="number" step="0.01" [(ngModel)]="draft.total_to_pay" [name]="'pay_' + draft.id" />
            </td>
            @if (salary_accounts.length) {
              <td>
                <mat-form-field appearance="outline" class="dense select-field account-field">
                  <mat-select [(ngModel)]="draft.holded_salary_account_id" [name]="'account_' + draft.id">
                    <mat-option [value]="null">—</mat-option>
                    @for (account of salary_accounts; track account.id) {
                      <mat-option [value]="account.id">{{ account.num }} {{ account.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </td>
            }
            <td class="row-actions">
              <button
                mat-icon-button
                type="button"
                (click)="saveDraft(draft)"
                [disabled]="draft.status === 'synced' || syncing_draft_id === draft.id || confirming"
                matTooltip="Guardar fila"
              >
                <mat-icon>save</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                color="accent"
                (click)="syncDraft(draft)"
                [disabled]="!canSyncDraft(draft)"
                [matTooltip]="
                  draft.status === 'synced'
                    ? 'Ya sincronizada con Holded'
                    : syncing_draft_id === draft.id
                      ? 'Sincronizando…'
                      : 'Sincronizar solo esta nómina con Holded'
                "
              >
                <mat-icon>{{ draft.status === 'synced' ? 'check_circle' : 'cloud_upload' }}</mat-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cerrar</button>
  <button
    mat-flat-button
    color="accent"
    type="button"
    (click)="confirm()"
    [disabled]="confirming || syncing_draft_id !== null || !drafts.length"
  >
    {{ confirming ? 'Sincronizando…' : 'Sincronizar todas con Holded' }}
  </button>
</mat-dialog-actions>
